'use client'

import dynamic from 'next/dynamic'
import { Box, ButtonBase, Typography } from '@mui/material'

// Types
import type { PainTabProps } from '@/types/components/molecules/home'

// Components
const MenuItemIconAtom = dynamic(() => import('@/components/atoms/icon/menu-item'))

// One tab of the pains bar; the active one shows a filling progress bar underneath
const PainTabMolecule = (props: PainTabProps) => {
	// Props
	const { icon, label, active, running, duration, onSelect, onDone } = props

	return (
		<ButtonBase
			onClick={onSelect}
			aria-pressed={active}
			sx={{ flex: '1 0 auto', minWidth: { xs: 150, md: 0 }, display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: 1.5, px: 1, pt: 1, borderRadius: 3 }}
		>
			<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
				<Box
					sx={{
						width: 36,
						height: 36,
						flexShrink: 0,
						borderRadius: 2.5,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						bgcolor: active ? 'primary.main' : 'common.white',
						color: active ? 'primary.contrastText' : 'grey.500',
						boxShadow: active ? '0 8px 16px -6px rgba(0, 156, 156, 0.6)' : 'none',
						transition: 'all .35s cubic-bezier(0.22, 1, 0.36, 1)',
						'& .MuiSvgIcon-root': { fontSize: 20 }
					}}
				>
					<MenuItemIconAtom name={icon} />
				</Box>

				<Typography sx={{ fontSize: 14, fontWeight: active ? 700 : 500, color: active ? 'text.primary' : 'text.secondary', whiteSpace: 'nowrap', transition: 'color .3s' }}>
					{label}
				</Typography>
			</Box>

			<Box sx={{ height: 3, borderRadius: 3, bgcolor: 'grey.300', overflow: 'hidden' }}>
				{active && (
					<Box
						onAnimationEnd={onDone}
						sx={{
							height: 1,
							bgcolor: 'primary.main',
							animation: `painProgress ${duration}ms linear forwards`,
							animationPlayState: running ? 'running' : 'paused',
							'@keyframes painProgress': { from: { width: '0%' }, to: { width: '100%' } },
							'@media (prefers-reduced-motion: reduce)': { animation: 'none', width: '100%' }
						}}
					/>
				)}
			</Box>
		</ButtonBase>
	)
}

export default PainTabMolecule
